import manualOrderProductColors from './manualOrderProductColors';

export default {
  template: '#purchase_product',
  components: {
    manualOrderProductColors,
  },
  props: ["product"],
  methods: {},
  data: function() {
    return {
      price: 0.00
    }
  },
  computed: {
    productColors: function() {
      return this.product.colors;
    }
  },
};


// WEBPACK FOOTER //
// ./app/assets/js/client-admin/designer/components/launch_tab/manualOrderProduct.js